<template>
  <div>
    <div class="mt-3" style="display: flex; flex-wrap: wrap">
      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Cliente</v-card-title>

            <v-card-subtitle v-text="itemi.REMITENTE.nombre"></v-card-subtitle>
          </div>
        </div>
      </v-card>
      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Destinatario</v-card-title>
            <v-card-subtitle v-text="itemi.DESTINATARIO.nombre"></v-card-subtitle>
            <v-card-subtitle
              style="margin-top:-35px;"
              v-text="itemi.DESTINATARIO.alias"
            ></v-card-subtitle>
            <v-card-subtitle
              style="margin-top:-35px;"
              v-text="itemi.DESTINATARIO.telefono"
            ></v-card-subtitle>
          </div>
        </div>
      </v-card>

      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div class=" mt-3d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Remitente</v-card-title>
            <v-card-subtitle v-text="itemi.TITULAR" v-if="itemi.TITULAR"></v-card-subtitle>
            <v-card-subtitle v-text="itemi.REMITENTE.nombre" v-else></v-card-subtitle>
            <v-card-subtitle
              style="margin-top:-35px;"
              v-text="itemi.REMITENTE.alias"
            ></v-card-subtitle>
            <v-card-subtitle
              style="margin-top:-35px;"
              v-text="itemi.REMITENTE.telefono"
            ></v-card-subtitle>
          </div>
        </div>
      </v-card>
      <!-- TODO se oculta cuando no hay servicio adicional? -->
      <v-card
        v-if="itemi.SERVICIO_ADICIONAL"
        elevation="6"
        style="width:300px;"
        class="mr-2 mt-3"
        color="blue"
        dark
      >
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Servicios adicionales</v-card-title>
            <v-card-subtitle></v-card-subtitle>
            <v-card-subtitle
              style="margin-top:-35px;"
              v-if="itemi.SERVICIO_ADICIONAL.correccion_direccion"
              >Correción dirección:
              {{
                reductorCorrecionDireccion(itemi.SERVICIO_ADICIONAL.correccion_direccion)
              }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;" v-if="itemi.SERVICIO_ADICIONAL.empaque"
              >Empaque: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.empaque) }}</v-card-subtitle
            >
            <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.rempaque" style="margin-top:-35px;"
              >Reempaque: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.rempaque) }}</v-card-subtitle
            >
            <v-card-subtitle
              v-if="itemi.SERVICIO_ADICIONAL.entrega_sabado"
              style="margin-top:-35px;"
              >Entrega en sábado:
              {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.entrega_sabado) }}</v-card-subtitle
            >
            <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.recoleccion" style="margin-top:-35px;"
              >Recolección:
              {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.recoleccion) }}</v-card-subtitle
            >
            <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.zona_expedida" style="margin-top:-35px;"
              >Zona extendida:
              {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.zona_expedida) }}</v-card-subtitle
            >
            <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.servicio_guia" style="margin-top:-35px;"
              >FLAT: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.servicio_guia) }}</v-card-subtitle
            >
            <v-card-subtitle v-if="itemi.SERVICIO_ADICIONAL.seguro" style="margin-top:-35px;"
              >Seguro: {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.seguro) }} (Valor declarado:
              {{ formateaMoneda(itemi.SERVICIO_ADICIONAL.valorcontenido) }})</v-card-subtitle
            >
          </div>
        </div>
      </v-card>
      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Dirección de destino</v-card-title>
            <v-card-subtitle>{{
              itemi.DIRECCION[itemi.DIRECCION.length - 1].direccion
            }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;"
              >{{ itemi.DIRECCION[itemi.DIRECCION.length - 1].colonia }} -
              {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].codigopostal }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >{{ itemi.DIRECCION[itemi.DIRECCION.length - 1].municipio }} -
              {{ itemi.DIRECCION[itemi.DIRECCION.length - 1].estado }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;">{{
              itemi.DIRECCION[itemi.DIRECCION.length - 1].pais
            }}</v-card-subtitle>
          </div>
        </div>
      </v-card>
      <v-card
        v-if="itemi.DIRECCION_REMITENTE"
        elevation="6"
        style="width:300px;"
        class="mr-2 mt-3"
        color="blue"
        dark
      >
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Dirección de origen</v-card-title>
            <v-card-subtitle>{{
              itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].direccion
            }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;"
              >{{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].colonia }} -
              {{
                itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].codigopostal
              }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >{{ itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].municipio }} -
              {{
                itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].estado
              }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;">{{
              itemi.DIRECCION_REMITENTE[itemi.DIRECCION_REMITENTE.length - 1].pais
            }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;">México</v-card-subtitle>
          </div>
        </div>
      </v-card>
      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Sucursal</v-card-title>
            <v-card-subtitle>{{ itemi.SUCURSAL }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;">
              Usuario: {{ itemi.USUARIO }}</v-card-subtitle
            >
          </div>
        </div>
      </v-card>
    </div>

    <!-- empieza mensajeria -->
    <div class="mt-3" style="display: flex; flex-wrap: wrap">
      <v-card
        v-for="(item4, index4) in itemi.PAQUETES.InfoMensajeria"
        :key="index4"
        elevation="6"
        style="width:300px;"
        class="mr-2 mt-3"
        color="blue"
        dark
        ><div style="text-align:center;">
          <span style="font-size:30px;font-weight:bold;"> MENSAJERIA</span>
        </div>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Mensaje #{{ index4 + 1 }}</v-card-title>
            <v-card-subtitle>Peso kg: {{ item4.pesokg }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;"
              >Guia: {{ formateaGuia(item4.guia) }}</v-card-subtitle
            >
          </div>
        </div>
      </v-card>
    </div>
    <!-- termina mensajeria -->

    <!-- empieza paquetes -->

    <div class="mt-3" style="display: flex; flex-wrap: wrap">
      <v-card
        v-for="(item3, index3) in itemi.PAQUETES.InfoPaquetes"
        :key="index3"
        elevation="6"
        style="width:300px;"
        class="mr-2 mt-3"
        color="blue"
        dark
        ><div style="text-align:center;">
          <span style="font-size:30px;font-weight:bold;"> PAQUETES</span>
        </div>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Paquete # {{ index3 + 1 }}</v-card-title>
            <v-card-subtitle>Alto: {{ item3.alto }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;">Largo: {{ item3.largo }} cm</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;">Ancho: {{ item3.ancho }} cm</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;"
              >Peso kg: {{ item3.pesokg }} kg</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >Peso vol: {{ item3.pesovol }} kg</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >Guia FEDEX: {{ formateaGuia(item3.guia) }}</v-card-subtitle
            >
          </div>
        </div>
      </v-card>
    </div>
    <!-- termina paquetes -->
    <!-- empieza abonos -->
    <div class="mb-3" style="display: flex; flex-wrap: wrap">
      <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
        <div style="text-align:center;">
          <span style="font-size:30px;font-weight:bold;"> ABONOS</span>
        </div>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Total</v-card-title>
            <v-card-subtitle>Total envio: {{ formateaMoneda(itemi.ABONOS.total) }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;">
              Deuda actual: {{ formateaMoneda(calculaDeudaActual(itemi.ABONOS)) }}</v-card-subtitle
            >
          </div>
        </div>
      </v-card>
      <v-card
        v-for="(item2, index2) in itemi.ABONOS.Abonos"
        :key="index2"
        elevation="6"
        style="width:300px;"
        class="mr-2 mt-3"
        color="blue"
        dark
      >
        <div class="d-flex flex-no-wrap justify-space-between">
          <div>
            <v-card-title class="headline">Abono #{{ index2 + 1 }}</v-card-title>
            <v-card-subtitle> Fecha: {{ item2.fecha }}</v-card-subtitle>
            <v-card-subtitle style="margin-top:-35px;"
              >Cantidad abonada: {{ formateaMoneda(item2.cantidad) }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >Método de pago: {{ item2.tipo_pago }}</v-card-subtitle
            >
            <v-card-subtitle style="margin-top:-35px;"
              >Usuario: {{ item2.usuario.nombre }}</v-card-subtitle
            >
          </div>
        </div>
        <v-btn
          block
          class="p-3"
          @click="
            $emit('reimprimir-abono', {
              fechaAbono: item2.fecha,
              cantidadAbonada: item2.cantidad,
              referencia: itemi.REFERENCIA,
              costoTotalEnvio: itemi.ABONOS.total,
              deudaActualEnvio: calculaDeudaActual(itemi.ABONOS),
              abonante: itemi.REMITENTE.nombre,
              totalAbonado: itemi.ABONOS.total - calculaDeudaActual(itemi.ABONOS)
            })
          "
          ><v-icon small class="mr-2"> mdi-printer </v-icon>REIMPRIMIR ABONO</v-btn
        >
      </v-card>
    </div>
    <!-- haciendo uso de bucles anidados iteramos primero por los paquetes y luego dentro de sus
    fracciones arancelarias -->
    <div
      v-if="
        itemi.DETALLE_ENVIO == 'Internacional Priority' ||
          itemi.DETALLE_ENVIO == 'Internacional Economy'
      "
      style="text-align:left;"
    >
      <span style="font-size:30px;font-weight:bold;"> FRACCIONES ARANCELARIAS</span><br />
    </div>
    <div
      v-if="
        itemi.DETALLE_ENVIO == 'Internacional Priority' ||
          itemi.DETALLE_ENVIO == 'Internacional Economy'
      "
      style="width:100%height:auto;display: flex; flex-wrap: wrap;"
    >
      <magic-grid
        :animate="true"
        style="width:300px;padding:5px 5px 5px 5px;"
        class="mb-2"
        v-for="(el, i) in itemi.PAQUETES.InfoPaquetes"
        :key="i"
      >
        <v-card elevation="6" color="blue" dark>
          <span style="font-size:20px;"> Paquete #{{ i + 1 }}</span>
          <ol>
            <li v-for="(fraccion, j) in el.fa" :key="j">
              {{ fraccion.id }}

              {{ fraccion.nombre }} / {{ fraccion.num_clasificacion }}<br />
              {{ fraccion.des_en }} <br />
              {{ fraccion.des_en }} <br />
              Cantidad: {{ fraccion.cantidad }} / Valor unitario: {{ fraccion.valor_unitario }}
            </li>
          </ol>
        </v-card>
      </magic-grid>
    </div>
  </div>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
export default {
  props: {
    itemi: Object
  },
  methods: {
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    reductorCorrecionDireccion(arrCostoDirecciones) {
      let total = 0;
      for (let index = 0; index < arrCostoDirecciones.length; index++) {
        total += parseFloat(arrCostoDirecciones[index]);
      }
      return total;
    },
    formateaGuia(guia) {
      return FormatoGuia(guia);
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    }
  }
};
</script>
<style lang="css"></style>
